import React, { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { withHighLight } from 'hoc/with-high-light';

const TypographyComponent: FC<TypographyProps> = ({ children, ...props }: TypographyProps) => (
    <Typography {...props} component="span">
        {children}
    </Typography>
);

const TypographyWithHighLighting: FC<{ data: string; originalData: string } & TypographyProps> =
    withHighLight(TypographyComponent);
export default TypographyWithHighLighting;
